// =============================================
// "!" on a field's border, with the field's help text as a tooltip
// =============================================
// Used on the Vendors / Customers / Other Parties form: the explanation that used to sit
// under a field is shown when the "!" is pointed at (or tapped), which keeps the form
// short. Rendered as two siblings INSIDE a .pm-field: the mark on the top border and
// the bubble, which spans the field's width so it is never cut off by the form's edge.
// No tab stop — Tab keeps going from field to field.
// =============================================
import React from 'react';

const PartyTip: React.FC<{ text?: string | null }> = ({ text }) => (text ? (
  <>
    <span
      className="pm-tip"
      tabIndex={-1}
      role="img"
      aria-label={text}
      onClick={e => { e.preventDefault(); (e.currentTarget as HTMLElement).focus(); }}   /* a tap shows it; never activates the field's label */
    >
      !
    </span>
    <span className="pm-tip-text" role="tooltip">{text}</span>
  </>
) : null);

export default PartyTip;
